<template>
  <div class="RfTester lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="RfTester-topCurve-wrapper lxn-w100">
      <CustomCurve>
      </CustomCurve>
    </div>
    <div class="RfTester-main-wrapper lxn-pos-rel lxn-margin-auto lxn-border-round">
      <TitleBox :titleBgColor="'blue'" bgColor="#ECECEC">
        <template v-slot:title>
          IR Code Convertor
        </template>
        <template v-slot:body>
          uuid
          <input v-model="nodeUUID" />
          <div style="height: 50px;"></div>
        </template>
      </TitleBox>
    </div>
    <div class="RfTester-button lxn-margin-auto lxn-w100">
      <CustomButton @click="testRF(433,0);" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
        433 UP
      </CustomButton>
      <div style="height: 10px;"></div>
      <CustomButton @click="testRF(433,1);" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
        433 STOP
      </CustomButton>
      <div style="height: 10px;"></div>
      <CustomButton @click="testRF(433,2);" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
        433 DOWN
      </CustomButton>
      <div style="height: 10px;"></div>
      <CustomButton @click="testRF(315,0);" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
        315 UP
      </CustomButton>
      <div style="height: 10px;"></div>
      <CustomButton @click="testRF(315,1);" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
        315 STOP
      </CustomButton>
      <div style="height: 10px;"></div>
      <CustomButton @click="testRF(315,2);" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
        315 DOWN
      </CustomButton>
      <div style="height: 10px;"></div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import CustomButton from '@/components/CustomButton.vue'
import TitleBox from '@/components/TitleBox.vue'
import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'
import * as CONFIGS from '@/statics/configs.js'
import NODE7 from '@/statics/devices/Node7/header.js'

export default {
  name: 'RfTester',
  components: {
    CustomCurve,
    CustomButton,
    TitleBox,
  },
  data: function () {
    return {
      nodeUUID: '',
    }
  },
  mounted: function () {
  },
  destroyed: function () {
  },
  watch: {
  },
  computed: {
    hub: function () {
      return this.$store.state.hubs[this.$store.state.hubs.length - 1];
    }
  },
  methods: {
    testRF: function (freq, ch) {
      var hub = this.hub;
      var valueOfChange = [];
      if(freq == 433){
        if(ch == 0){
          valueOfChange = [82,0,4,104,1,213,2,213,2,104,1,242,18,220,5,213,2,170,30,43,181,91,191,119,175,215,68,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];
        }else if(ch == 1){
          valueOfChange = [82,0,4,104,1,213,2,213,2,104,1,242,18,220,5,213,2,170,30,43,181,91,191,119,175,182,196,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];
        }else if(ch == 2){
          valueOfChange = [82,0,4,104,1,213,2,213,2,104,1,242,18,220,5,213,2,170,30,43,181,91,191,119,175,239,16,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];
        }
      }else if(freq == 315){
        if(ch == 0){
          valueOfChange = [50,0,3,210,0,133,2,133,2,210,0,210,0,1,26,43,127,86,234,236,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];
        }else if(ch == 1){
          valueOfChange = [50,0,3,210,0,133,2,133,2,210,0,210,0,1,26,43,127,86,234,188,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];
        }else if(ch == 2){
          valueOfChange = [50,0,3,210,0,133,2,133,2,210,0,210,0,1,26,43,127,86,234,220,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];
        }
      }

      this.$store.commit('setAppBusy', true);
      var messagingHook = new Messaging(new Logger(false));
      messagingHook.init({
        psk: hub.psk,
        destinationUUID: hub.uuid,
        sourceUUID: this.$store.state.user.uuid
      });
      this.$store.dispatch('setNodesParameters', {
        messagingHook: messagingHook,
        hubUUID: hub.uuid,
        bodyContent: {
          nodeActions: [
            {
              nodeUUID: this.nodeUUID,
              actions: [
                {
                  parameterId: 17920,
                  valueOfChange: valueOfChange,
                  typeOfAction: 0,
                  timeDelay: 0
                }
              ]
            }
          ],
        }
      })
      .then( () => {
        console.log("Sent Rf on " + freq + "MHz channel " + ch);
      })
      .catch( response => {
        if(response.rejectCode == 2){
          this.$store.commit('setHubStatus', {
            hubIndex: response.hubIndex,
            connectionStatus: {
              local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
            },
          });
        }
      })
      .finally( () => {
        this.$store.commit('setAppBusy', false);
      })
    },
  }
}
</script>

<style>
  .RfTester-topCurve-wrapper {
    height: 200px;
  }
  .RfTester-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 2;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding: 14px;
  }
  .RfTester-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
</style>
